// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__3JAIn","wrapper_declined":"styles_wrapper_declined__dDVpj"};